import React, { useEffect, useState } from 'react';
import './ProfileContainer.css';
import { ProfilePicture } from '../profile-container/profile-picture/ProfilePicture';
import flag from '../../assets/images/flag.png';
import { MediaLinks } from './media-links/MediaLinks';

export const ProfileContainer = () => {    
    const [word, setWord] = useState(0);
    let words = ['code', 'design', 'draw', 'teach']
    
    useEffect(() => {
        setTimeout(() => {
            if (word > words.length - 2){
                setWord((word) => 0)
            }else{
                setWord((word) => word + 1);
            }
        }, 1500);            
    });
    
    return (
        <div className='profile-container'>
            <div className='profile-container'>
                <ProfilePicture />
                <h1 className='profile-name'>DIEGO ESCOBAR</h1>
                <h2 className='profile-title'>CODER AND WEB DEVELOPER</h2>
                <img src={flag} alt="Colombia" />
                <p className='profile-description'>I’m a coder with knowledge and experience designing and building websites, web apps and desktop apps with the most powerful technology.</p>
                <p className='profile-description' id='textAnimated'>Besides, I like to <span className='word'>{words[word]}</span></p>
                <MediaLinks />
            </div>            
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/profile-container/ProfileContainer.jsx